import React, { useState, useEffect } from 'react';
import { Accordion, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { FaChevronRight, FaChevronDown, FaTrashAlt, FaSave } from "react-icons/fa"; 
import RunToggleButton from './FormComponents/RunToggleButton'
import SampleGroup from './FormComponents/SampleGroup'
import ShortCircuitGroup from './FormComponents/ShortCircuitGroup'
import TextGroup from './FormComponents/TextGroup'
import ExcludeIfGroup from './FormComponents/ExcludeIfGroup'


const FormSearchRules = (props) => {
  const [rules, setRules] = useState(props.rules);
  const [advancedCollapsed, setAdvancedCollapsed] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setRules(props.rules);
  }, [props.rules]);

  useEffect(() => {
    props.setSampleRows({
      size: rules.sample.row.size,
      every: rules.sample.row.every
    });
  }, [rules]);

  const sampleUpdateHandler = (obj, property) => {
    if (obj.active) {
      setRules({
        ...rules,
        sample: {
          ...rules.sample,
          [property]: {
            active: obj.active,
            size: obj.size,
            every: obj.every
          }
        }
      })
    } else if (obj.active === false) {
      let newRules = JSON.parse(JSON.stringify(rules));
      delete newRules.sample[property];
      setRules(newRules);
    }
  }

  const excludeUpdateHandler = (obj, type) => {
    if (obj.active) {
      setRules({
        ...rules,
        exclude_if: {
          column: {
            ...rules.exclude_if.column,
            [type]: obj[type]
          }
        }
      })
    } else {
      let newRules = JSON.parse(JSON.stringify(rules));
      delete newRules.exclude_if.column[type];
      setRules(newRules);
    }
  }

  return (
    <Container>
      {/* <Row className="text-left mt-3 mb-2">
        <Col>
          <RunToggleButton 
            dryRun={rules.dry_run} 
            update={(value) => setRules({ ...rules, dry_run: value })} 
          />          
        </Col>
      </Row> */}
      <Row className="mb-3">
        <Col>
          <TextGroup
            text="Name"
            helperText="( Ex: My Discovery Run V1)"
            value={rules.name} 
            onChange={(value) => setRules({ ...rules, name: value })}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <TextGroup
            text="Minimum sampled rows"
            helperText="( Ex: My Discovery Run V1)"
            value={rules.minimum_sampled_rows} 
            onChange={(value) => setRules({ ...rules, minimum_sampled_rows: value })}
            type='number'
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <SampleGroup
            setSampleRows={(obj) => props.setSampleRows(obj)}
            name={'row'} 
            sample={rules.sample.row} 
            update={(value) => sampleUpdateHandler(value, 'row')}
          />
        </Col>
      </Row>
      <Accordion defaultActiveKey="1">
        <Accordion.Toggle 
          className="text-secondary pointer-cursor text-left mb-3" 
          onClick={() => setAdvancedCollapsed(!advancedCollapsed)}
          as="div" 
          eventKey="0"
        >
          <Row className="advanced-collapse mb-2">
            <Col>
              { advancedCollapsed === false ? 
                <FaChevronRight className="mb-1 mr-2" /> : 
                <FaChevronDown className="mb-1 mr-2" /> } 
              Advanced
            </Col>
          </Row>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <div>
            <Row>
              <Col>
                <ExcludeIfGroup 
                  sample={'column'} 
                  location={'Type'} 
                  active={rules.exclude_if.column.Type === undefined ? false : true} 
                  value={rules.exclude_if.column.Type ? rules.exclude_if.column.Type : ''}
                  update={(value) => excludeUpdateHandler(value, "Type")}
                />
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col>
                <ExcludeIfGroup
                  sample={'column'} 
                  location={'Field'} 
                  active={rules.exclude_if.column.Field === undefined ? false : true} 
                  value={rules.exclude_if.column.Field ? rules.exclude_if.column.Field : ''}
                  update={(value) => excludeUpdateHandler(value, "Field")}
                />
              </Col>
            </Row>
          </div>
        </Accordion.Collapse>
      </Accordion>
      {/* Sampling rule sets are one global admin-managed list. Non-admins get a read-only view —
          hide Save and Delete for them. */}
      { props.canEdit &&
        <Row>
          <Col>
            <div className='d-flex justify-content-end'>
              { id &&
                <div className='mr-2'>
                  <Button
                    onClick={() => props.deleteRulesHandler(rules)}
                    variant="outline-light"
                    size='sm'
                    className="export-data-button w-100"
                    disabled={props.fetchingData}
                  >
                    <FaTrashAlt className='mr-2' />
                    { props.fetchingData &&
                      <Spinner
                        className='mr-2'
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                      />
                    }
                    DELETE
                  </Button>
                </div>
              }
              <div>
                <Button
                  className="w-100"
                  size='sm'
                  onClick={() => props.saveRulesHandler(rules)}
                  disabled={props.saving}
                  variant='primary primary'
                >
                  { props.saving ? (
                    <Spinner
                      className='mr-2'
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    />
                  ) : (
                    <FaSave className='mr-2' />
                  )}
                  SAVE
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      }
    </Container>
  );
}


export default FormSearchRules
